/** Convert an event-local wall time to UTC, independent of the visitor's location. */
function partsAt(instant, timeZone) {
  const formatter = new Intl.DateTimeFormat("en-US", {
    timeZone, year: "numeric", month: "2-digit", day: "2-digit",
    hour: "2-digit", minute: "2-digit", hourCycle: "h23"
  });
  return Object.fromEntries(formatter.formatToParts(instant)
    .filter(({ type }) => ["year", "month", "day", "hour", "minute"].includes(type))
    .map(({ type, value }) => [type, Number(value)]));
}

export function eventLocalToUtc(value, timeZone) {
  const match = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})$/.exec(value || "");
  if (!match) throw new Error("Select a valid event date and time.");
  const [year, month, day, hour, minute] = match.slice(1).map(Number);
  const wallTimestamp = Date.UTC(year, month - 1, day, hour, minute);
  if (!Number.isFinite(wallTimestamp)) throw new Error("Invalid event date.");
  let utc = wallTimestamp;
  for (let iteration = 0; iteration < 4; iteration += 1) {
    const parts = partsAt(new Date(utc), timeZone);
    const interpretedAsUtc = Date.UTC(parts.year, parts.month - 1, parts.day, parts.hour, parts.minute);
    const adjusted = utc + (wallTimestamp - interpretedAsUtc);
    if (adjusted === utc) break;
    utc = adjusted;
  }
  const actual = partsAt(new Date(utc), timeZone);
  if ([actual.year, actual.month, actual.day, actual.hour, actual.minute]
    .some((item, index) => item !== [year, month, day, hour, minute][index])) {
    throw new Error("This local time does not exist in the event timezone (daylight saving change). Please select another time.");
  }
  return new Date(utc).toISOString();
}
